// Generated with util/create-slice.js
import React from 'react';

import { createSlice, PayloadAction, createEntityAdapter, EntityState, EntityAdapter } from '@reduxjs/toolkit';
import axios from 'axios';
import { AppThunk, RootState } from '../..';
import { hideBackdrop } from '../global';

export interface ReportingDashboard {
	status: string | undefined;
}

// interface GlobalApp {
//     isLoaded?: boolean;
//     backDropProps: DynamicBackdropProps | null;
//   }

//   interface GlobalAppState extends GlobalApp {
//   }

//   const initialState: GlobalAppState = {
//     isLoaded: false,
//     backDropProps: { title: '', visible: false },
//   };

export interface SchoolCohortSaveState extends ReportingDashboard {
	allItemsLoaded: boolean | null;
	isLoading: boolean;
	isUpdating: boolean;
	statusMessage: string | undefined;
	error: any;
}

export const initialState: SchoolCohortSaveState = {
	status: undefined,
	allItemsLoaded: false,
	isLoading: false,
	isUpdating: false,
	statusMessage: undefined,
	error: null,
};

const slice = createSlice({
	name: 'save-school-cohort',
	initialState,
	reducers: {
		saveSchoolCohort(state: SchoolCohortSaveState) {
			console.log(`Save School Cohort state`);
			state = { ...state, statusMessage: 'fetching' };
			return state;
		},
		saveSchoolCohortSuccess(state: SchoolCohortSaveState, action: PayloadAction<any[]>) {
			state = {
				...state,
				isLoading: false,
				error: null,
				statusMessage: 'success',
			};
			console.log(`State for Save School Cohort adapter success`);
			return state;
		},
		saveSchoolCohortFailure(state: SchoolCohortSaveState, action: PayloadAction<string>) {
			console.log(`Error State for adapter ${JSON.stringify(action.payload, null, '	')}`);
			state = {
				...state,
				isLoading: false,
				error: action.payload,
				statusMessage: 'failure',
			};
			return state;
		},
	},
});

// Entity Actions
export const { actions } = slice;

// Entity Reducer
export const reducer = slice.reducer;

export default slice;
